<template>
  <div
    v-show="showCardForm"
    id="card-details"
    class="panel panel-default panel-body"
  >
    <h5 class="strong">
      {{ lang.get('payment-subscriptions.titles.card-details') }}
    </h5>

    <div class="form-group">
      <label for="cardNumber">{{
        lang.get('payment-subscriptions.form.card-number.label')
      }}</label>
      <div id="cardNumber" class="form-control"></div>
    </div>

    <div class="form-group">
      <label for="cardHolder">{{
        lang.get('payment-subscriptions.form.card-holder.label')
      }}</label>
      <input
        id="cardHolder"
        ref="cardHolder"
        type="text"
        name="cardHolder"
        class="form-control"
      />
    </div>
    <div class="form-group">
      <label for="cardExpiry">{{
        lang.get('payment-subscriptions.form.expiration-date.label')
      }}</label>
      <div id="cardExpiry" class="form-control card-element-small"></div>
    </div>
    <div class="form-group">
      <label for="cardCvc">CVV</label>
      <div id="cardCvc" class="form-control card-element-small"></div>
    </div>
    <input ref="cardToken" type="hidden" name="cardToken" :value="cardToken" />
  </div>
</template>

<script>
import langMixin from './Translations/mixins/lang-mixin.js';

export default {
  mixins: [langMixin],
  props: {
    stripeKey: {
      type: String,
      required: true
    },
    showCardForm: {
      type: Boolean,
      default: true
    },
    clearCardForm: {
      type: Boolean,
      default: false
    },
    threeDSecure: {
      type: Boolean,
      default: false
    },

    threeDSecureData: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      stripe: null,
      elements: null,
      cardElement: null,
      cardExpiryElement: null,
      cardCvcElement: null,
      isCardNumberOk: false,
      isExpiryOk: false,
      isCvcOk: false,
      cardToken: null
    };
  },
  computed: {
    isComplete() {
      return this.isCardNumberOk && this.isExpiryOk && this.isCvcOk;
    }
  },
  watch: {
    clearCardForm() {
      this.cardElement.clear();
      this.cardExpiryElement.clear();
      this.cardCvcElement.clear();
      this.$refs['cardHolder'].value = '';
    },

    isComplete(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.stripe.createToken(this.cardElement).then(res => {
          if (res.error) {
            this.$emit('cardTokenError', res.error.message);
            this.cardToken = null;
          } else if (res.token) {
            this.cardToken = res.token.id;
            this.$emit('cardToken', res.token.id);
          }
        });
      } else if (!newVal && oldVal) {
        this.cardToken = null;
        this.$emit('resetCardToken', true);
      }
    },

    threeDSecure(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.stripe
          .confirmCardPayment(this.threeDSecureData.client_secret, {
            payment_method: this.threeDSecureData.payment_method
          })
          .then(result => {
            if (
              result.paymentIntent &&
              result.paymentIntent.status === 'succeeded'
            ) {
              this.$emit('paymentIntentSuccess', result);
            } else {
              const error = this.lang.has(result.error.code)
                ? this.lang.get(result.error.code)
                : result.error.message;
              this.$emit('paymentIntentError', error);
            }
          });
      }
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.stripe = new Stripe(this.stripeKey);
    this.elements = this.stripe.elements();

    const cardClasses = {
      base: 'card-element-base',
      focus: 'card-element-focus'
    };

    this.cardElement = this.elements.create('cardNumber', {
      showIcon: true,
      iconStyle: 'default',
      classes: cardClasses
    });
    this.cardElement.mount('#cardNumber');
    this.cardElement.on('change', e => (this.isCardNumberOk = e.complete));

    this.cardExpiryElement = this.elements.create('cardExpiry', {
      classes: cardClasses
    });
    this.cardExpiryElement.mount('#cardExpiry');
    this.cardExpiryElement.on('change', e => (this.isExpiryOk = e.complete));

    this.cardCvcElement = this.elements.create('cardCvc', {
      classes: cardClasses,
      placeholder: 'CVV'
    });
    this.cardCvcElement.mount('#cardCvc');
    this.cardCvcElement.on('change', e => (this.isCvcOk = e.complete));
  }
};
</script>

<style scoped>
.card-element-base {
  padding-top: 10px !important;
}

.card-element-focus {
  border-color: #000 !important;
  outline: 0;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.7) !important;
}

.card-element-focus {
  border-color: #333 !important;
  outline: 0;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6) !important;
}

.card-element-small {
  width: 80px;
}
</style>
